interface Error {
    request: {},
    response: {
        status: number
    }
}

const unauthorizedHandler = (error: Error) => {
    const { response } = error
    if (response && response.status === 401 && !location.pathname.includes("login") && !location.pathname.includes("new_password")) {
        location.href = "/login"
    }

    return Promise.reject(error.response)
}

export default unauthorizedHandler
